/**
 * @generated SignedSource<<acbaf537a7ec4e7d2f17b37878e97950>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ConfiguratorUrlInput = {
  customToken?: string | null;
  modelID?: number | null;
  productID?: string | null;
};
export type ShoppingPreview_shoppingPreviewUrl_Query$variables = {
  input: ConfiguratorUrlInput;
};
export type ShoppingPreview_shoppingPreviewUrl_Query$data = {
  readonly shoppingPreviewUrl: string | null;
};
export type ShoppingPreview_shoppingPreviewUrl_Query = {
  response: ShoppingPreview_shoppingPreviewUrl_Query$data;
  variables: ShoppingPreview_shoppingPreviewUrl_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "shoppingPreviewUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShoppingPreview_shoppingPreviewUrl_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShoppingPreview_shoppingPreviewUrl_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0b498dc1fdd2c0ba5aab982215d38189",
    "id": null,
    "metadata": {},
    "name": "ShoppingPreview_shoppingPreviewUrl_Query",
    "operationKind": "query",
    "text": "query ShoppingPreview_shoppingPreviewUrl_Query(\n  $input: ConfiguratorUrlInput!\n) {\n  shoppingPreviewUrl(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "62ca50e20253a4b3fb0cd4176d8f17ce";

export default node;
